// extracted by mini-css-extract-plugin
export var label = "_er-2";
export var slideContainer = "_er-0";
export var slider = "_er-1";